module.exports = __webpack_public_path__ + "img/2.59706cc8.png";